module.exports = __webpack_public_path__ + "img/pickup_marker.7ab7ef8f.svg";